"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var computeNormalizer = function (response, quantities, request, status) {
    if (quantities === void 0) { quantities = {}; }
    if (request === void 0) { request = {}; }
    var cart = response.cart, _a = response.currency_code, currency_code = _a === void 0 ? '' : _a, _b = response.country, country = _b === void 0 ? '' : _b, tax = response.tax, totals = response.totals, cart_totals = response.cart_totals, processor_discounts = response.processor_discounts, _c = response.shipping_methods, shipping_methods = _c === void 0 ? [] : _c, errors = response.errors;
    var cartSkuKeys = Object.keys(cart) || [];
    var formatCartSkus = {};
    var subtotalOriginal = 0;
    var totalQuantity = 0;
    cartSkuKeys.forEach(function (skuKey) {
        var cartSku = cart[skuKey];
        var quantity = cartSku.quantity, discount = cartSku.discount, price = cartSku.price, originalPrice = cartSku.original_price, cart_page_display_price = cartSku.cart_page_display_price;
        totalQuantity += quantity;
        formatCartSkus[skuKey] = {
            quantity: quantity,
            discount: discount,
            price: price,
            originalPrice: originalPrice,
            currency: currency_code,
            country: country,
            cartPageDisplayPrice: cart_page_display_price,
        };
        if (Object.keys(quantities[skuKey].extraInfo || {}).length) {
            formatCartSkus[skuKey]['hasCustomPrice'] = true;
            subtotalOriginal += originalPrice;
        }
        else {
            subtotalOriginal += originalPrice * quantity;
        }
    });
    var skuTaxes = {};
    for (var key in tax.sku_taxes) {
        if (Object.hasOwnProperty.call(tax.sku_taxes, key)) {
            var element = tax.sku_taxes[key];
            var normalizedEl = {
                taxAmount: element.tax_amount,
                taxRate: element.tax_rate,
            };
            if (element.included_vat_rate) {
                normalizedEl.includedVATRate = element.included_vat_rate;
            }
            skuTaxes[key] = normalizedEl;
        }
    }
    var normalisedTaxObject = {
        rate: tax.rate,
        amount: tax.amount,
        includedVATAmount: tax.included_vat_amount,
        includedVATRate: tax.included_vat_rate,
        skuTaxes: skuTaxes,
    };
    var errorMapping = null;
    if (errors) {
        errorMapping = {};
        errors.map(function (_a) {
            var error_field_name = _a.error_field_name, error_description = _a.error_description;
            return (errorMapping[error_field_name] = error_description);
        });
    }
    var data = {
        status: status,
        error: response === null || response === void 0 ? void 0 : response.error,
        totals: {
            couponDiscount: totals.coupon_discount,
            discountTotal: totals.discount_total,
            referralDiscount: totals.referral_discount,
            couponAbsoluteAmount: totals.coupon_absolute_amount || 0,
            usedCredits: totals.credits_used,
            shipping: totals.shipping,
            subtotal: totals.subtotal,
            total: totals.total,
            subtotalOriginal: subtotalOriginal,
        },
        cartTotals: {
            subtotalOriginal: subtotalOriginal,
            couponDiscount: cart_totals.coupon_discount,
            discountTotal: cart_totals.discount_total,
            shipping: cart_totals.shipping || 0,
            subtotal: cart_totals.subtotal,
            total: cart_totals.total,
        },
        processorDiscounts: {
            extraTenPercentDiscount: processor_discounts.ten_percent_off_threshold_discount_processor,
        },
        totalQuantity: totalQuantity,
        cart: formatCartSkus,
        country: country,
        currency: currency_code,
        tax: normalisedTaxObject,
        shippingMethod: request.shipping_method,
        shippingMethods: shipping_methods,
        quantities: quantities,
        couponCode: request.coupon_code,
    };
    if (errorMapping && errorMapping.referral_discount) {
        data.referralCode = null;
    }
    else {
        data.referralCode = request.referral;
    }
    data.errors = errorMapping;
    return data;
};
exports.default = computeNormalizer;
